import { API } from "apis";
import FileInput from "components/common/input/FileInput";
import { ContextModel, CorpModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React, { ChangeEvent } from "react";
import { Utils } from "utils";
import DialogBase from "./DialogBase";

type PROPS = {
  ctx: ContextModel;
  modalIsOpen: boolean;
  targets: CorpModel[];
  close: (result: boolean) => void;
};

/** 「お問い合わせ内容を登録」ダイアログ */
const ContactDialog: React.FC<PROPS> = (props) => {
  /** 件名 */
  const [title, setTitle] = React.useState("");
  /** 内容 */
  const [message, setMessage] = React.useState("");
  /** ファイル */
  const [files, setFiles] = React.useState<CommonFileModel[]>([{ file_name: "", file_data: "", image_url: "" }]);

  const close = (result: boolean) => {
    setTitle("");
    setMessage("");
    setFiles([{ file_name: "", file_data: "", image_url: "" }]);

    props.close(result);
  };

  const onChangeTitle = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };
  const onChangeMessage = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const onSend = async () => {
    console.log("送信する");

    const tmp = files.filter((v) => Utils.hasFile(v));

    let s = "";
    s += `件名: ${title}\n`;
    s += `内容: ${message}\n`;
    s += `ファイル(${files.length})\n`;
    for (let i = 0; i < tmp.length; i++) {
      const file = files[i];
      s += `- ${file.file_name}\n`;
    }
    console.log(s);

    props.ctx.loading.setState(true);
    try {
      const response = await API.Thread.inquiryCreate({
        thread: {
          thread_title: title,
          message,
          file: tmp,
        },
        receive_corp_list: props.targets.map((v) => {
          return { receive_corp_id: v.corp_id };
        }),
      });
      console.log(response);
      props.ctx.msgDialog.setState({
        message: "お問い合わせを送信しました。",
        callback: () => {
          close(true);
        },
      });
    } catch (err) {
      Utils.errorAction(props.ctx, err);
    }
    props.ctx.loading.setState(false);
  };

  React.useEffect(() => {
    if (props.modalIsOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "inherit";
    }
  }, [props.modalIsOpen]);

  React.useEffect(() => {
    return (() => {
      document.body.style.overflow = "inherit";
    })
  }, []);

  return (
    <DialogBase modalIsOpen={props.modalIsOpen} title="お問い合わせ内容を登録" close={() => close(false)}>
      <div className="p-4 flex flex-col gap-4">
        <div>
          <div>お問い合わせ先</div>
          <div className="p-4">
            {props.targets.map((target, index) => (
              <div key={index}>{target.corp_name}</div>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="whitespace-nowrap">
            件名
            <span className="ml-2 text-red-500 font-bold">*</span>
          </div>
          <input className="w-96" value={title} onChange={onChangeTitle} />
        </div>
        <div className="flex items-start gap-4">
          <div className="whitespace-nowrap pt-2">
            内容
            <span className="ml-2 text-red-500 font-bold">*</span>
          </div>
          <textarea className="w-96 rounded-none " value={message} rows={10} onChange={onChangeMessage} />
        </div>
        <div className="flex flex-col gap-2">
          {files.map((v, i) => {
            return (
              <FileInput
                key={i}
                data={v}
                onChange={(data) => {
                  const tmp = files.filter((v) => !!v.file_name);
                  if (tmp.length < 10) {
                    tmp.push({ file_name: "", file_data: "", image_url: "" });
                  }
                  setFiles(tmp);
                }}
                accept=".xlsx,.xls,.docx,.doc,.txt,.pdf,.jpg,.png,.gif,.zip"
                ctx={props.ctx}
                name="添付ファイル"
                maxSize={10}
              />
            );
          })}
        </div>

        <div className="flex justify-center">
          <button className="primary px-4 py-2" onClick={onSend}>
            送信する
          </button>
        </div>
      </div>
    </DialogBase>
  );
};

export default ContactDialog;
